import React from 'react';
import { CheckCircle } from 'lucide-react';

const AutoSaveIndicator = ({ autoSaving, lastSaved }) => {
  if (!autoSaving && !lastSaved) return null;

  return (
    <div className="flex items-center gap-2 px-3 py-1 bg-gray-50 border border-gray-200 rounded-full">
      {autoSaving ? (
        <>
          <div className="w-2 h-2 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          <span className="text-xs font-medium text-blue-700">Saving...</span>
        </>
      ) : lastSaved ? (
        <>
          <CheckCircle className="w-3 h-3 text-green-600" />
          <span className="text-xs font-medium text-green-700">
            Saved {new Date(lastSaved).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
          </span>
        </>
      ) : null}
    </div>
  );
};

export default AutoSaveIndicator;
